{
    "Accessibility menu": "Meni dostopnosti",
    "Close": "Zapri",
    "Content adjustments": "Prilagoditve vsebine",
    "Navigation adjustments": "Prilagoditve navigacije",
    "Text Align": "Text Align",
    "Align Left": "Poravnaj levo",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Prilagodi velikost pisave",
    "Highlight Title": "Označi naslov",
    "Highlight Links": "Označi povezave",
    "Readable Font": "Bralna pisava",
    "Colour adjustments": "Prilagoditve barv",
    "Dark Contrast": "Temni kontrast",
    "Light Contrast": "Svetli kontrast",
    "High Contrast": "Visoki kontrast",
    "High Saturation": "Visoka nasičenost",
    "Low Saturation": "Nizka nasičenost",
    "Monochrome": "Monokromno",
    "Tools": "Orodja",
    "Reading Guide": "Bralni vodnik",
    "Big Cursor": "Velik kazalec",
    "Increase Font Size": "Povečaj velikost pisave",
    "Decrease Font Size": "Zmanjšaj velikost pisave",
    "Letter Spacing": "Razmik med črkami",
    "Line Height": "Višina vrstice",
    "Font Weight": "Debelina pisave",
    "Dyslexia Font": "Pisava za disleksijo",
    "Language": "Jezik",
    "Accessibility widget": "Odpri meni dostopnosti",
    "Accessibility Profiles": "Profili dostopnosti",
    "Cognitive Disability": "Kognitivna oviranost",
    "Seizure Safe": "Varno za napade",
    "Accessibility statement": "Izjava o dostopnosti",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Ustavi animacije",
    "Reset all settings": "Ponastavi nastavitve",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
